module.exports = __webpack_public_path__ + "static/media/logo.eb596911.svg";